import React from 'react';

import { observer } from 'mobx-react-lite';
import { CallIncomingType } from 'stores/call_incoming_store';
import useStores from 'hooks/useStores';


type CallIncomingContextType = {

    //    createCallIncoming: (incoming_phone_number: string, associated_type: string, associated_uuid: string) => Promise<CallIncomingType>;

    // Fetch and get one
    fetchCallIncoming: (uuid: string) => Promise<CallIncomingType | null>;
    getCallIncoming: (uuid: string) => CallIncomingType | null;

    // Fetch and get list by identity
    fetchListByIdentityCallIncoming: (identity_uuid: string, cursor: string) => Promise<CallIncomingType[]>;
    getListByIdentityCallIncoming: (identity_uuid: string) => CallIncomingType[];

    // Fetch and get list by association
    fetchListByAssociationCallIncoming: (identity: string, associated_type: string, associated_uuid: string) => Promise<CallIncomingType[]>;
    getListByAssociationCallIncoming: (associated_type: string, associated_uuid: string) => CallIncomingType[];

    // Fetch and get list by IncomingPhoneNumber
    fetchListByIncomingPhoneNumber: (identity: string, incoming_phone_number: string) => Promise<CallIncomingType[]>;
    getListByIncomingPhoneNumber: (incoming_phone_number: string) => CallIncomingType[];

    // Contains all known CallIncoming items
    callIncomingItems: CallIncomingType[];
}

export const CallIncomingContext = React.createContext<CallIncomingContextType>({
    //    createCallIncoming: () => { throw 'Not Implemented' },
    fetchCallIncoming: () => { throw 'Not Implemented' },
    getCallIncoming: () => { throw 'Not Implemented' },
    fetchListByIdentityCallIncoming: () => { throw 'Not Implemented' },
    getListByIdentityCallIncoming: () => { throw 'Not Implemented' },
    fetchListByAssociationCallIncoming: () => { throw 'Not Implemented' },
    getListByAssociationCallIncoming: () => { throw 'Not Implemented' },
    fetchListByIncomingPhoneNumber: () => { throw 'Not Implemented fetchListByIncomingPhoneNumber' },
    getListByIncomingPhoneNumber: () => { throw 'Not Implemented getListByIncomingPhoneNumber' },
    callIncomingItems: [] as CallIncomingType[],
});




export const CallIncomingProvider = observer(({ children }: { children: React.ReactNode }) => {

    const { callIncomingStore } = useStores();

    // const addItems = (newItems: CallIncomingType[] | CallIncomingType) => {
    //     // Autogenerated
    //     newItems = Array.isArray(newItems) ? newItems : [newItems];
    //     setCallIncoming([...items, ...newItems]);
    // };

    const fetchCallIncoming = async (uuid: string) => {
        // Autogenerated
        return callIncomingStore.fetchCallIncoming(uuid);
    };

    const getCallIncoming = (uuid: string) => {
        // Autogenerated
        return callIncomingStore.items.find((item) => item.uuid === uuid) || null;
    };

    const fetchListByIdentityCallIncoming = async (identity_uuid: string) => {
        // Autogenerated
        return callIncomingStore.fetchListByIdentityCallIncoming(identity_uuid)
            .then(() => {
                return getListByIdentityCallIncoming(identity_uuid);
            });
    };

    const getListByIdentityCallIncoming = (identity_uuid: string) => {
        // Autogenerated
        return callIncomingStore.items.slice().filter((item) => item.identity === identity_uuid);
    };


    // const createCallIncoming = async (incoming_phone_number: string, associated_type: string, associated_uuid: string) => {
    //     // Autogenerated
    //     return callIncomingStore.createCallIncoming(incoming_phone_number, associated_type, associated_uuid)
    //         .then((newCallIncoming) => {
    //             setCallIncoming([...items, newCallIncoming]);
    //             return newCallIncoming;
    //         });
    // };

    const fetchListByAssociationCallIncoming = async (identity: string, associated_type: string, associated_uuid: string) => {
        // Autogenerated
        return callIncomingStore.fetchListByAssociationCallIncoming(identity, associated_type, associated_uuid)
            .then(() => {
                return getListByAssociationCallIncoming(associated_type, associated_uuid);
            });
    };

    const getListByAssociationCallIncoming = (associated_type: string, associated_uuid: string) => {
        // Autogenerated
        return  callIncomingStore.items.slice().filter((item) => item.associated_type === associated_type && item.associated_uuid === associated_uuid);
    };

    const fetchListByIncomingPhoneNumber = async (identity: string, incoming_phone_number: string) => {
        // Autogenerated
        return callIncomingStore.fetchListByIncomingPhoneNumber(identity, incoming_phone_number)
            .then(() => {
                return getListByIncomingPhoneNumber(incoming_phone_number);
            });
    };

    const getListByIncomingPhoneNumber = (incoming_phone_number: string) => {
        console.log("getListByIncomingPhoneNumber incoming_phone_number: ", incoming_phone_number);
        console.log(callIncomingStore.items[0]);
        return callIncomingStore.items.slice().filter((item) => item.incoming_phone_number === incoming_phone_number)
            .sort((a: CallIncomingType, b: CallIncomingType) => {
            return a.date_created < b.date_created ? 1 : -1;
        });
    };


    const data = {
        fetchCallIncoming,
        getCallIncoming,
        fetchListByIdentityCallIncoming,
        getListByIdentityCallIncoming,
        fetchListByAssociationCallIncoming,
        getListByAssociationCallIncoming,
        fetchListByIncomingPhoneNumber,
        getListByIncomingPhoneNumber,
        callIncomingItems: callIncomingStore.items,
    };

    return (
        <CallIncomingContext.Provider value={data}>{ children }</CallIncomingContext.Provider>
    );

});
